export default __webpack_public_path__ + "static/media/sur-terre.b0982740.svg";